/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

import Table from 'react-bootstrap/Table';

import ListingTemplate from '../../../components/Template/ListingTemplate';
import Loader from '../../../components/Loader';
import api from '../../../services/api';

import { useToast } from '../../../context/ToastContext';

import { IPermission } from '../../../interfaces/IPermission';

interface PaymentMethodsFormDataDTO {
  id: number;
  financial_account_id: number;
  name: string;
  days_compensation: number;
  allow_installments: boolean;
  fee: number;
  is_active: boolean;
}

interface PermissionDTO {
  permissions: IPermission;
}

const ReadsPaymentMethods: React.FC<PermissionDTO> = ({ permissions }) => {
  const [loading, setLoading] = useState(false);
  const [listPaymentMethods, setListPaymentMethods] = useState<
    PaymentMethodsFormDataDTO[]
  >([]);
  const [
    listPaymentMethodsPaginatedItems,
    setListPaymentMethodsPaginatedItems,
  ] = useState<any[]>([]);
  const { addToast } = useToast();

  useEffect(() => {
    try {
      const getListPaymentMethods = async (): Promise<void> => {
        try {
          setLoading(true);
          const response = await api.get('cash/payment-methods');
          setListPaymentMethods(response.data);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          // eslint-disable-next-line no-shadow
          if (error.response) {
            const { data } = error.response; // Error vindo do back está em data dentro de response
            addToast({
              type: 'error',
              title: data.message,
            });
            return;
          }

          addToast({
            type: 'error',
            title: 'Ocorreu um erro interno',
          });
        }
      };
      getListPaymentMethods();
    } catch (error) {
      setLoading(false);
      // eslint-disable-next-line no-shadow
      if (error.response.data) {
        const { data } = error.response; // Error vindo do back está em data dentro de response
        addToast({
          type: 'error',
          title: data.message,
        });
        return;
      }

      addToast({
        type: 'error',
        title: 'Ocorreu um erro interno',
      });
    }
  }, [addToast]);

  const handleListPaymentMethodsPaginatedItems = useCallback(newList => {
    setListPaymentMethodsPaginatedItems(newList);
  }, []);

  return (
    <ListingTemplate
      title="Formas de Pagamento"
      module="cash/payment-methods"
      listItemsProps={listPaymentMethods}
      handleListItemsPaginatedItems={handleListPaymentMethodsPaginatedItems}
      placeHolderProp="Cód. FORMA DE PAG."
      permissions={permissions}
    >
      {(loading && <Loader />) || (
        <>
          <Table striped bordered hover size="sm" responsive="md">
            <thead className="text-center text-primary text-uppercase">
              <tr>
                <th className="font-weight-normal py-3" scope="col">
                  ID
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Nome
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Dias de compensação
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Taxa
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Permitir Parcelamento
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Forma de Pagamento Ativa
                </th>
                <th className="font-weight-normal py-3" scope="col">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              {listPaymentMethodsPaginatedItems.map((item, index) => (
                <tr key={index.toString()}>
                  <th scope="row">{item.id}</th>
                  <td className="text-left">{item.name}</td>
                  <td>{item.days_compensation}</td>
                  <td className="text-right pr-3">{item.fee}</td>
                  <td>
                    {(item.allow_installments === true && ' SIM') || ' NÃO'}
                  </td>
                  <td>{(item.is_active === true && ' SIM') || ' NÃO'}</td>
                  <td>
                    {(permissions.update && (
                      <Link to={`/cash/payment-methods/read/${item.id}`}>
                        Alterar
                      </Link>
                    )) || <span className="text-cinza-51-5bits">Alterar</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </ListingTemplate>
  );
};

export default ReadsPaymentMethods;
